export const IconUserProfileContact20: {
  name: 'icon_user_profile_contact_20-2040ba8a1cd4'
} = {
  name: 'icon_user_profile_contact_20-2040ba8a1cd4'
}
